import React, { Component } from 'react';
import styles from './TelStyles';
import telDebug from './telDebug';

const serverUrl = 'https://jadmx.dezhuyun.com'

// 真机排查用的状态日志：统一 [Tel] 前缀，telDebug 面板里好过滤；只记录不改行为
const tlog = (...args) => {
  try {
    console.log('[Tel]', ...args)
  } catch (e) {}
}

const IMAGE = {
  SPEAKER_ON: 'https://cdn.ihealthlabs.com.cn/app/finger/Hy7cmdCfr.png',
  SPEAKER_OFF: 'https://cdn.ihealthlabs.com.cn/app/finger/SwEPaGdza.png',
  HANGUP: 'https://cdn.ihealthlabs.com.cn/app/finger/IM_qzncF2.png',
}

class Tel extends Component {
  state = {
    rnData: {},
    call: false,
    callDuration: 0,      // 通话持续时间(秒)
    isInCall: false,       // 是否正在通话中
    callStatus:'',
    speaker:false
};

  // 组件挂载后执行
  componentDidMount() {
    telDebug.install(); // 先装采集钩子，再加载 icall，脚本加载过程也能记到
    this.checkRNData();
    window.addEventListener('message', this.handleRNMessage);
  }

  // 解析URL参数的工具函数
  getUrlParams = () => {
    const params = {};
    // 获取当前URL的查询部分
    const queryString = window.location.search;
    
    if (queryString) {
      // 移除问号并分割参数
      const paramPairs = queryString.slice(1).split('&');
      
      paramPairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
          // 解码URL参数（处理特殊字符）
          params[key] = decodeURIComponent(value);
        }
      });
    }
    
    return params;
  };

  checkRNData = () => {
    const urlParams = this.getUrlParams();
    tlog('checkRNData', 'token长度=' + (urlParams.token ? urlParams.token.length : 0), 'phone=' + (urlParams.phone || ''), 'nickname=' + (urlParams.nickname || ''));
    if (urlParams.token) {
      // 构建rnData对象，包含从URL获取的参数
      const rnData = {
        token: urlParams.token,
        phone: urlParams.phone,
        nickname: urlParams.nickname || '',
      };
      
      this.setState({ rnData });
      this.loadICallScript();
    }else{
      tlog('URL缺token → 上报NOT_DATA（RN会提示并关闭本页）');
      this.notifyNative({ type: 'NOT_DATA' });
    }
  };

  // 加载icall脚本
  loadICallScript = () => {
    // 避免重复创建脚本标签
    if (this.script) return;

    this.script = document.createElement('script');
    // 添加时间戳防止缓存
    this.script.src = `${serverUrl}/dzfront/icall/lib/icall.js?time=${Date.now()}`;
    
    this.script.onload = this.handleScriptLoad;
    this.script.onerror = this.handleScriptError;

    tlog('开始加载icall.js', this.script.src);
    document.body.appendChild(this.script);
  };

  // 脚本加载成功处理
  handleScriptLoad = () => {
    tlog('icall.js加载成功', 'DeZhuFrontIcall存在=' + !!window.DeZhuFrontIcall);
    if (!window.DeZhuFrontIcall) {
      console.error('icall.js加载成功，但未找到DeZhuFrontIcall对象');
      return;
    }

    const container = document.getElementById('myCall');
    if (!container) {
      console.error('未找到id为myCall的DOM元素，无法初始化iCall');
      return;
    }

    this.initICall(container);
  };

  // 初始化iCall实例
  initICall = (container) => {
    // const rnData = window.RNData || {};
    const { rnData } = this.state
    // 检查token是否存在
    if (!rnData || !rnData.token) {
      tlog('initICall时无token → 上报NOT_DATA');
      this.notifyNative({ type: 'NOT_DATA' });
      return;
    }

    // 初始化iCall实例
    tlog('initICall: 创建DeZhuFrontIcall实例，等init回调后signIn');
    this.iCall = new window.DeZhuFrontIcall(container, {
      option: {
        server: serverUrl,
        token: rnData.token,
      },
      event: {
        onCallStatusChange: (status) => {
          tlog('onCallStatusChange:', status, '| isInCall=' + this.state.isInCall + ' duration=' + this.state.callDuration);
          this.setState({ callStatus: status });
          this.notifyNative({ type: 'STATUS_CHANGE', data: status,callDuration:this.state.callDuration });
          
          // 检查是否进入通话状态
          const activeStatus = ['INBOUND_ACTIVE', 'MANUAL_ACTIVE'];
          const isActiveCall = activeStatus.includes(status);
          
          if (isActiveCall && !this.state.isInCall) {
            // 开始计时
            this.startCallTimer();
          } else if (!isActiveCall && this.state.isInCall) {
            // 结束计时
            this.stopCallTimer();
          }
        },
        onCallDataChange: (data) => {
          tlog('onCallDataChange:', data);
          this.notifyNative({ type: 'DATA_CHANGE', data });
        },
        onCallFail: () => {
          tlog('onCallFail → 上报FAIL（RN会置fail并立即关闭本页，体感=闪退）');
          this.notifyNative({ type: 'FAIL' });
        },
        onUserStatusChange: (status) => {
          tlog('onUserStatusChange:', status, '| 已发起拨号call=' + this.state.call);
          this.notifyNative({ type: 'text',data:status });
          // 仅在未发起呼叫且状态为NOT_READY时发起呼叫
          if (!this.state.call && status === 'NOT_READY') {
            tlog('满足唯一拨号条件 → setUserStatus(PRESENCE_READY) + call(' + rnData.phone + ')');
            this.iCall.setUserStatus('PRESENCE_READY');
            this.iCall.call(rnData.phone);
            this.setState({ call: true });
          } else if (!this.state.call) {
            tlog('未触发拨号（状态不是NOT_READY；若始终等不到NOT_READY，页面会一直停在"正在呼叫…"）');
          }
        },
        onFinishedAcw: (acwDuration) => {
          tlog('onFinishedAcw(话后处理结束):', acwDuration);
          this.notifyNative({ type: 'END',data:acwDuration });
        }
      }
    }, async () => {
      console.log('iCall初始化完成，执行登录签入');
      this.iCall.signIn();
      this.notifyNative({ type: 'text',data:'iCall初始化完成，执行登录签入' });
    });
  };

  // 脚本加载失败处理
  handleScriptError = () => {
    tlog('icall.js加载失败（script onerror，多为网络/证书问题）');
    console.error('icall.js加载失败');
  };

  handleRNMessage = (event) => {
    try {
      // 解析RN传递的JSON数据（RN端需用JSON.stringify序列化）
      const rnParams = JSON.parse(event.data);
      tlog('收到RN消息:', rnParams);

      // 根据参数类型处理（示例：处理扬声器状态更新）
      if (rnParams.type === 'UPDATE_SPEAKER') {
        // 更新本地扬声器状态
        this.setState({ speaker: rnParams.value });
      }
    } catch (error) {
      console.error('解析RN消息失败:', error);
    }
  };

  // 通知原生应用
  // 通知原生应用；取证模式（日志面板开着）下，会导致 RN 关闭本页的消息先暂缓，
  // 等复制完日志（或超时 120s）再放行——面板没开的普通用户行为完全不变
  notifyNative = (data) => {
    tlog('→RN postMessage:', data);
    if (this._holdQueue) {
      this._holdQueue.push(data);
      tlog('页面关闭已暂停，该消息已排队待发');
      return;
    }
    const isCloseMsg =
      data &&
      (data.type === 'FAIL' ||
        (data.type === 'STATUS_CHANGE' && ['INBOUND_NOT_ACTIVE', 'MANUAL_NOT_ACTIVE'].includes(data.data)));
    if (isCloseMsg && telDebug.isPanelOpen()) {
      this._holdQueue = [data];
      telDebug.holdForCopy(() => {
        const q = this._holdQueue || [];
        this._holdQueue = null;
        q.forEach(d => this._postToRN(d));
      });
      return;
    }
    this._postToRN(data);
  };

  _postToRN = (data) => {
    // 替换可选链操作符，兼容不支持该语法的环境
    if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
      try {
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      } catch (error) {
        console.error('向原生应用发送消息失败:', error);
      }
    } else {
      console.warn('ReactNativeWebView不存在或postMessage方法不可用，无法发送消息');
    }
  };


  componentWillUnmount() {
    tlog('unmount: 清理计时器并signOut（本页即将销毁）');
    // 清理计时器
    this.stopCallTimer();
    if (this.callTimer) {
      clearInterval(this.callTimer);
      this.callTimer = null;
    }
    
    // 清理iCall实例
    if (this.iCall && typeof this.iCall.signOut === 'function') {
      try {
        this.iCall.signOut();
      } catch (error) {
        console.error('iCall签出失败:', error);
      }
    }
    
    // 移除脚本标签
    if (this.script && document.body.contains(this.script)) {
      document.body.removeChild(this.script);
    }

    window.removeEventListener('message', this.handleRNMessage);
    
    // 清除引用
    this.script = null;
    this.iCall = null;
  }

  // 格式化时长显示
  formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    // 格式化数字为两位数
    const pad = (num) => num.toString().padStart(2, '0');
    
    if (hours > 0) {
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    } else {
      return `${pad(minutes)}:${pad(secs)}`;
    }
  };

  // 启动通话计时
  startCallTimer = () => {
    tlog('通话计时开始（UI从"正在呼叫…"切到时长显示）');
    // 如果已经在计时则清除
    if (this.callTimer) {
      clearInterval(this.callTimer);
    }
    
    // 记录开始时间
    this.setState({
      callDuration: 0,
      isInCall: true
    });
    
    // 每秒更新一次时长
    this.callTimer = setInterval(() => {
      this.setState(prevState => ({
        callDuration: prevState.callDuration + 1
      }));
    }, 1000);
  };

  // 停止通话计时
  stopCallTimer = () => {
    if (this.state.isInCall) {
      tlog('通话计时停止, 本次时长=' + this.state.callDuration + 's');
    }
    if (this.callTimer) {
      clearInterval(this.callTimer);
      this.callTimer = null;
    }
    this.setState({ isInCall: false });
  };
  
  render() {
    const { rnData,isInCall,callDuration,speaker } = this.state;
    return (
      <div>
        {/* iCall 需要的 DOM 容器 */}
        <div id="myCall" style={{display:'none'}}></div>
        <div style={{...styles.mainContainer}}>
          <div style={styles.callInfoContainer} onClick={telDebug.handleTap}>
            {isInCall ? (
              <div style={styles.statusText}>
                {this.formatDuration(callDuration)}
              </div>
            ) : (
              <div style={styles.statusText}>
                正在呼叫…
              </div>
            )}
            <div style={styles.nicknameText}>
              {rnData.nickname}
            </div>
          </div>

          <div style={styles.buttonAreaContainer}>
            <div style={styles.buttonGroup}>
              {/* 免提按钮 */}
              {/* <div 
                style={styles.buttonItem}
                onClick={() => {
                  const data = {
                    type: 'BTN',
                    data: speaker ? 1 : 0
                  };
                  this.notifyNative(data);
                }}
              >
                <img 
                  src={speaker ? IMAGE.SPEAKER_ON : IMAGE.SPEAKER_OFF}
                  style={styles.buttonImage}
                />
                <div style={styles.buttonText}>免提</div>
              </div> */}

              {/* 结束按钮（组合基础样式+额外间距） */}
              <div 
                style={{...styles.buttonItem, ...styles.endButton}}
                onClick={() => {
                  tlog('点击结束按钮 call=' + this.state.call, this.state.call ? '→ iCall.hangup()' : '→ 未拨号，直接通知RN关闭(BTN 2)');
                  if (this.state.call) {
                    this.iCall.hangup();
                  } else {
                    this.notifyNative({ type: 'BTN', data: 2 });
                  }
                }}
              >
                <img 
                  src={IMAGE.HANGUP}
                  style={styles.buttonImage}
                />
                <div style={styles.buttonText}>结束</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tel;
    





// WEBPACK FOOTER //
// ./src/modules/tel/index.js